import type { ActionNodeData } from "../nodes/ActionNode";

/**
 * Draft fields cleared when returning to the action type picker (placeholder step only).
 * Matches ConditionConfigPanel.handleBackToPicker intent: keep the graph node, reset configuration.
 */
export function getActionDraftResetForTypePicker(): Partial<ActionNodeData> {
    return {
        actionCode: undefined,
        actionType: undefined,
        title: undefined,
        isPlaceholder: true,
        message: undefined,
        onceOnly: undefined,
        responseType: undefined,
        templateId: undefined,
        templateName: undefined,
        templateIntegId: undefined,
        hasMedia: undefined,
        mediaFileList: undefined,
        components: undefined,
        fieldNameAndValueMap: undefined,
        notificationTypes: undefined,
        notifyUser: undefined,
        notifyUserLabel: undefined,
        notifyMessage: undefined,
        recordOwner: undefined,
        accountOwner: undefined,
        includeAdditionalEmails: undefined,
        additionalEmails: undefined,
        logRecordAsThread: undefined,
        logRecordsFor: undefined,
        delayDays: undefined,
        delayHours: undefined,
        delayMinutes: undefined,
    };
}
